import { parse } from "tldts";

const extractEmailDomain = (email: string) => {
  if (!email.includes("@")) return null;
  const parsed = parse(email);
  return parsed.domain ?? "";
};

export default extractEmailDomain;
